<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<!-- Overlay spinner for add / update / delete operations -->
@if (formLoading) {
  <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.75);display:flex;align-items:center;justify-content:center;z-index:9999;">
    <p-progressSpinner strokeWidth="4" animationDuration=".6s"></p-progressSpinner>
  </div>
}

<p-table #pt [value]="landingPageCMSs" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="landingPageCMSId" selectionMode="single"
  [(selection)]="landingPageCMS" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Landing Page CMS</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Landing Page CMS +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Landing Page CMS +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'landingPageCMSId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'displayUrl', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="searchLocationId" [options]="locations" appendTo="body"
          (onChange)="pt.filter($event.value, 'searchLocationId', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'searchName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-landingPageCMS>
    <tr [pSelectableRow]="landingPageCMS">
      <td>{{landingPageCMS.landingPageCMSId}} </td>
      <td>{{landingPageCMS.name}}</td>
      <td>{{landingPageCMS.description}}</td>
      <td>{{landingPageCMS.displayUrl}}</td>
      <td>{{getSearchLocationName(landingPageCMS)}}</td>
      <td>{{landingPageCMS.searchName}}</td>
      <td>{{landingPageCMS.searchCheckInDate | date}}</td>
      <td>{{landingPageCMS.searchCheckOutDate | date}}</td>
      <td>{{landingPageCMS.searchCheckInDateStart | date}}</td>
      <td>{{landingPageCMS.searchCheckOutDateEnd | date}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(landingPageCMS)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>